export default __webpack_public_path__ + "static/media/hemwatiriver.8efcce43.jpg";